import React from 'react';

function Home() {
  return (
    <div>
      <h3 className='display-3'>Welcome to Blogging!</h3>
    </div>
  );
}

export default Home;
